//Paquetes NPM de GYF.
import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';

//ACTION TYPES
export const GET_DATA_VISTA_INSTANCIA_PARAMETROS = 'GET_DATA_VISTA_INSTANCIA_PARAMETROS';
export const GET_DATA_VISTA_INSTANCIA_PARAMETROS_DATA = 'GET_DATA_VISTA_INSTANCIA_PARAMETROS_DATA';
export const RESET_STATE_VISTA_INSTANCIA_PARAMETROS = 'RESET_STATE_VISTA_INSTANCIA_PARAMETROS';
export const SET_ENTIDAD_INSTANCIA_ID = "SET_ENTIDAD_INSTANCIA_ID";
export const LIMPIAR_RUTEO_ATLAS = "LIMPIAR_RUTEO_ATLAS";
export const NUEVA_ENTIDAD_INSTANCIA = "NUEVA_ENTIDAD_INSTANCIA";
export const GET_DATA_VISTA_INSTANCIA_PARAMETROS_PAGINADO = 'GET_DATA_VISTA_INSTANCIA_PARAMETROS_PAGINADO';
export const LOADING_ATLAS = 'LOADING_ATLAS';
export const SELECT_COMBO = 'SELECT_COMBO';
export const SELECT_RADIO = 'SELECT_RADIO';
export const UPDATE_INPUT_FILTRO = 'UPDATE_INPUT_FILTRO';
export const ELIMINAR_FILTRO = 'ELIMINAR_FILTRO';
export const GET_ENTIDAD_RELACIONADA = 'GET_ENTIDAD_RELACIONADA';
export const LIMPIAR_FILTROS = 'LIMPIAR_FILTROS';
export const MOSTRAR_FILTROS = 'MOSTRAR_FILTROS';
export const ERROR_FILTROS = 'ERROR_FILTROS';
export const CAMBIAR_FILTRO_ACTIVO = 'CAMBIAR_FILTRO_ACTIVO';
export const CARGAR_FILTROS_DEFINITIVOS = 'CARGAR_FILTROS_DEFINITIVOS';
export const ERROR_VALIDACION_FORMATO_FILTRO = 'ERROR_VALIDACION_FORMATO_FILTRO';

let _dispatch, _routingState = null, _cantidadPaginas, idInstanciaGloabl;

//SECCION ARMAR COMBO FILTROS
export function getEntidadRelacionada() {
    return (dispatch, getState) => {

        let entidadId = parseInt(getState().atlas.entidadId);

        let idEntidad = {
            "ENTIDAD_ID": entidadId
        }

        let params = {
            "ENTIDAD_ID": entidadId,
            "ENTIDAD_INSTANCIA_ID": 0
        }

        LogHelper.Out(getEntidadRelacionada.name, params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_EQUIVALENCIAS', 'Get', 'Atlas', 'Atlas', 1, 'Product');

        Engine1Proxy.Execute((data) => _obtenerEntidadRelacionada(data), null, null);
    }
}

function _obtenerEntidadRelacionada(data) {
    LogHelper.In(_obtenerEntidadRelacionada.name, data);

    let dataInstanciaParametro = {
        nombreEntidad: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].NombreEntidad,
        codigoEntidad: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].Codigo,
        generoEntidad: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].Genero,
        requiereEquivalencia: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset0.Rows[0].RequiereEquivalencia,
        instancias: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset1.Rows,
        instanciaEquivalencias: JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset2.Rows,
        equivalencias: JSON.parse(data.GET_EQUIVALENCIAS).Recordset0.Rows
    }

    let ejecutarRequests = false;

    _convertirFechaDB(dataInstanciaParametro.instancias);

    dataInstanciaParametro.instancias.forEach((ins, index) => {
        if (ins.EntidadRelacionadaId) {
            ejecutarRequests = true;

            let params = { "ENTIDAD_ID": ins.EntidadRelacionadaId, "PROPIEDAD_ID": ins.PropiedadId }

            LogHelper.Out(_obtenerEntidadRelacionada.name, (params, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID", "Get", "Atlas", "Atlas", 1, "Product",
                true, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID_" + index));
            Engine1Proxy.AddDataSourcesRequests(params, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID", "Get", "Atlas", "Atlas", 1, "Product",
                true, "GET_ENTIDAD_RELACIONADA_BY_ENTIDADID_" + index);
        }
    });

    if (ejecutarRequests) {
        Engine1Proxy.Execute((data) => {
            Object.keys(data).forEach(o => {
                if (o.indexOf("GET_ENTIDAD_RELACIONADA_BY_ENTIDADID_") >= 0) {
                    const result = JSON.parse(data[o]).Recordset0.Rows;

                    dataInstanciaParametro.instancias.forEach((ins) => {
                        if (result.length > 0 && ins.Codigo == result[0].CodigoPropiedad) {
                            ins.entidadRelacionada = result;
                        }
                    });
                }
            });
            _dispatch({ type: GET_ENTIDAD_RELACIONADA, dataInstanciaParametro });
        });
    } else {
        _dispatch({ type: GET_ENTIDAD_RELACIONADA, dataInstanciaParametro });
    }
}

export function mostrarFiltros(valor) {
    return (dispatch) => {
        dispatch({ type: MOSTRAR_FILTROS, valor });
    }
}

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} currentScope
 */
export function getDataVistaInstanciaParametro(entidadId, currentScope) {
    LogHelper.In(getDataVistaInstanciaParametro.name, entidadId, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();

        dispatch({ type: GET_DATA_VISTA_INSTANCIA_PARAMETROS, state });

        let currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _cargaInicialVistaInstanciaParametro(data, entidadId, true), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * Resetea el estado inicial
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: RESET_STATE_VISTA_INSTANCIA_PARAMETROS });
        dispatch({ type: LIMPIAR_RUTEO_ATLAS });
    }
}

/**
 * 
 * @param {any} objEntidadInstancia
 */
export function setearEntidadInstancia(objEntidadInstancia) {
    LogHelper.In(setearEntidadInstancia.name, objEntidadInstancia);

    return (dispatch) => {
        dispatch({ type: SET_ENTIDAD_INSTANCIA_ID, ...objEntidadInstancia });
    }
}

/**
 * 
 * @param {any} objNuevaEntidadInstancia
 */
export function crearNuevaEntidadInstancia(objNuevaEntidadInstancia) {
    LogHelper.In(crearNuevaEntidadInstancia.name, objNuevaEntidadInstancia);

    return (dispatch) => {
        dispatch({ type: NUEVA_ENTIDAD_INSTANCIA, ...objNuevaEntidadInstancia });
    }
}

export function selectCombo(campo, id, index) {
    LogHelper.In(selectCombo.name, id);

    return (dispatch, getState) => {
        dispatch({ type: SELECT_COMBO, id, campo, index });
    }
}

export function selectRadio(valor, index, propiedadId) {
    LogHelper.In(selectRadio.name, valor, index);

    return (dispatch, getState) => {
        dispatch({ type: SELECT_RADIO, valor, index, propiedadId });
    }
}

export function updateInputFiltro(valor, codigo) {
    LogHelper.In(updateInputFiltro.name, valor, codigo);

    return (dispatch) => {
        dispatch({ type: UPDATE_INPUT_FILTRO, valor, codigo });
    }
}

export function eliminarFiltro(id, registrosActivos) {
    LogHelper.In(eliminarFiltro.name, id);

    return (dispatch, getState) => {

        let arrayFiltros = getState().vistaInstanciaParametro.data.arrayFiltros;

        if (arrayFiltros.length == 1) {
            dispatch({ type: ELIMINAR_FILTRO, id });

            let arrayFiltrosDefinitivo = getState().vistaInstanciaParametro.data.arrayFiltrosDefinitivo;

            if (arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 0) {
                _dispatch({ type: CARGAR_FILTROS_DEFINITIVOS, array: [] });
                _dispatch({ type: LOADING_ATLAS, valor: true });

                _cargaInicialVistaInstanciaParametro(null, idInstanciaGloabl, registrosActivos)
            }
        } else {
            dispatch({ type: ELIMINAR_FILTRO, id });
        }
    }
}

export function getInstanciasLimpiarFiltros(registrosActivos, arrayFiltrosDefinitivoLength) {
    LogHelper.In(getInstanciasLimpiarFiltros.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        let arrayInicialAux = getState().vistaInstanciaParametro.data.instanciasComboInicial;
        //Artilugio generado para que se tome el valor como una copia y no como una referencia directa de la variable "data.instanciasComboInicial"
        let arrayInicial = arrayInicialAux ? arrayInicialAux.filter(x => x.EstaVisible) : [];
        
        _dispatch({ type: LIMPIAR_FILTROS, arrayInicial});

        if (arrayFiltrosDefinitivoLength && arrayFiltrosDefinitivoLength > 0) {
            _dispatch({ type: LOADING_ATLAS, valor: true });
            _cargaInicialVistaInstanciaParametro(null, idInstanciaGloabl, registrosActivos)
        }
    }
}

export function buscarDatosFiltrados(registrosActivos) {
    LogHelper.In(buscarDatosFiltrados.name);
    return (dispatch, getState) => {

        dispatch({ type: LOADING_ATLAS, valor: true });
        dispatch({ type: CAMBIAR_FILTRO_ACTIVO, filtrosActivos: true });

        let arrayFiltros = getState().vistaInstanciaParametro.data.arrayFiltros;
        let id = arrayFiltros[0].instancia.EntidadId;
        let mostrarActivos = registrosActivos ? registrosActivos : null;
        //Artilugio generado para que se tome el valor como una copia y no como una referencia directa del array "data.arrayFiltros"
        let arrayDefinitivo = arrayFiltros.filter(x => x.propiedadId);

        let hayError = validarDatosFiltros(arrayFiltros);
        let hayErrorFormato = arrayFiltros.filter(x => x.errorFormato || x.errorFechaInvalida ).length > 0

        if (hayErrorFormato) {
            dispatch({ type: LOADING_ATLAS, valor: false });
        } else if (hayError.length > 0) {

            dispatch({ type: ERROR_FILTROS, arrayError: hayError });
            dispatch({ type: LOADING_ATLAS, valor: false });

        } else {

            dispatch({ type: ERROR_FILTROS, arrayError: false });
            dispatch({ type: CARGAR_FILTROS_DEFINITIVOS, array: arrayDefinitivo });

            let idEntidad = {
                "ENTIDAD_ID": parseInt(id)
            }

            let params = {
                "ENTIDAD_ID": parseInt(id),
                "ENTIDAD_INSTANCIA_ID": 0
            }

            LogHelper.Out(_cargaInicialVistaInstanciaParametro.name, idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
            LogHelper.Out(_cargaInicialVistaInstanciaParametro.name, params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');

            let entidadDatos = {
                'ENTIDAD_ID': parseInt(id),
                'NUMERO_PAGINA': 1,
                'REGISTROS_ACTIVOS': mostrarActivos,
                'CANTIDAD_REGISTROS': null,

                'PROPIEDAD_ID_1': arrayFiltros.length > 0 ? arrayFiltros[0].instancia.PropiedadId : null,
                'VALOR_PROPIEDAD_1': arrayFiltros.length > 0 ? obtenerValorPropiedad(arrayFiltros[0]) : null,
                'TIPO_BUSQUEDA_PROPIEDAD_1': arrayFiltros.length > 0 ? obtenerTipoDeBusqueda(arrayFiltros[0]) : null,

                'PROPIEDAD_ID_2': arrayFiltros.length > 1 ? arrayFiltros[1].instancia.PropiedadId : null,
                'VALOR_PROPIEDAD_2': arrayFiltros.length > 1 ? obtenerValorPropiedad(arrayFiltros[1]) : null,
                'TIPO_BUSQUEDA_PROPIEDAD_2': arrayFiltros.length > 1 ? obtenerTipoDeBusqueda(arrayFiltros[1]) : null,

                'PROPIEDAD_ID_3': arrayFiltros.length > 2 ? arrayFiltros[2].instancia.PropiedadId : null,
                'VALOR_PROPIEDAD_3': arrayFiltros.length > 2 ? obtenerValorPropiedad(arrayFiltros[2]) : null,
                'TIPO_BUSQUEDA_PROPIEDAD_3': arrayFiltros.length > 2 ? obtenerTipoDeBusqueda(arrayFiltros[2]) : null,

                'PROPIEDAD_ID_4': arrayFiltros.length > 3 ? arrayFiltros[3].instancia.PropiedadId : null,
                'VALOR_PROPIEDAD_4': arrayFiltros.length > 3 ? obtenerValorPropiedad(arrayFiltros[3]) : null,
                'TIPO_BUSQUEDA_PROPIEDAD_4': arrayFiltros.length > 3 ? obtenerTipoDeBusqueda(arrayFiltros[3]) : null,

                'PROPIEDAD_ID_5': arrayFiltros.length > 4 ? arrayFiltros[4].instancia.PropiedadId : null,
                'VALOR_PROPIEDAD_5': arrayFiltros.length > 4 ? obtenerValorPropiedad(arrayFiltros[4]) : null,
                'TIPO_BUSQUEDA_PROPIEDAD_5': arrayFiltros.length > 4 ? obtenerTipoDeBusqueda(arrayFiltros[4]) : null,
            }

            LogHelper.Out(_cargaInicialVistaInstanciaParametro.name, (entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product'));
            Engine1Proxy.AddDataSourcesRequests(entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product');

            Engine1Proxy.Execute((data) => _loadInicialVistaInstanciaParametroInitialStateData(data, id), null, null);
        }
    }
}

function validarDatosFiltros(arrayFiltros) {
    let arrayError = [];

    arrayFiltros.map((arr, index) => {
        if (arr.instancia.TipoCodigo == "DATETIME" || arr.instancia.TipoCodigo == "TEXT") {
            if (!arr.valorInput || arr.valorInput == "") {
                let errorIndex;
                errorIndex = index;
                arrayError.push(errorIndex);
            }
        }
        if (arr.instancia.TipoCodigo == "SELECT") {
            if (!arr.optionSeleccionado || arr.optionSeleccionado == "-1") {
                let errorIndex;
                errorIndex = index;
                arrayError.push(errorIndex);
            }
        }
    });

    return arrayError;
}

function obtenerValorPropiedad(arrayFiltros) {
    let valorPropiedad = null;

    switch (arrayFiltros.instancia.TipoCodigo) {
        case "SELECT":
            valorPropiedad = arrayFiltros.optionSeleccionado ? arrayFiltros.optionSeleccionado.trim() : "";
            break;
        case "CHECK":
            valorPropiedad = arrayFiltros.optionSeleccionado ? arrayFiltros.optionSeleccionado.trim() : "";
            break;
        case "DATETIME":
            //Si llegase a contener hora la fecha enviada, se toma únicamente la fecha
            let fecha = arrayFiltros.valorInput ? arrayFiltros.valorInput.trim().substr(0,10) : "";
            let time = " " + arrayFiltros.valorInput ? arrayFiltros.valorInput.trim().substr(11,5) : "";
            let fechaArray = fecha.split("-");

            valorPropiedad = fechaArray[1] + '-' + fechaArray[0] + '-' + fechaArray[2];
            valorPropiedad = time.trim() == "" ? valorPropiedad : valorPropiedad + time;
            break;
        default:
            valorPropiedad = arrayFiltros.valorInput ? arrayFiltros.valorInput.trim() : "";
            break;
    }

    return valorPropiedad;
}

function obtenerTipoDeBusqueda(arrayFiltros) {
    let tipoDeBusqueda = null;

    if (arrayFiltros.instancia.TipoCodigo == "TEXT" || arrayFiltros.instancia.TipoCodigo == "DATETIME") {
        tipoDeBusqueda = arrayFiltros.valorRadioButton == "E" ? true : false;
    }

    return tipoDeBusqueda;
}

function _cargaInicialVistaInstanciaParametro(data, id, registrosActivos) {
    LogHelper.In(_cargaInicialVistaInstanciaParametro.name, data, id);

    idInstanciaGloabl = id;

    let idEntidad = {
        "ENTIDAD_ID": parseInt(id)
    }

    let params = {
        "ENTIDAD_ID": parseInt(id),
        "ENTIDAD_INSTANCIA_ID": 0
    }

    LogHelper.Out(_cargaInicialVistaInstanciaParametro.name, idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    LogHelper.Out(_cargaInicialVistaInstanciaParametro.name, params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');

    let entidadDatos = {
        'ENTIDAD_ID': parseInt(id),
        'NUMERO_PAGINA': 1,
        'REGISTROS_ACTIVOS': registrosActivos,
        'CANTIDAD_REGISTROS': null,
        'PROPIEDAD_ID_1': null,
        'VALOR_PROPIEDAD_1': null,
        'TIPO_BUSQUEDA_PROPIEDAD_1': null,
        'PROPIEDAD_ID_2': null,
        'VALOR_PROPIEDAD_2': null,
        'TIPO_BUSQUEDA_PROPIEDAD_2': null,
        'PROPIEDAD_ID_3': null,
        'VALOR_PROPIEDAD_3': null,
        'TIPO_BUSQUEDA_PROPIEDAD_3': null,
        'PROPIEDAD_ID_4': null,
        'VALOR_PROPIEDAD_4': null,
        'TIPO_BUSQUEDA_PROPIEDAD_4': null,
        'PROPIEDAD_ID_5': null,
        'VALOR_PROPIEDAD_5': null,
        'TIPO_BUSQUEDA_PROPIEDAD_5': null,
    }

    LogHelper.Out(_cargaInicialVistaInstanciaParametro.name, (entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product'));
    Engine1Proxy.AddDataSourcesRequests(entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product');

    Engine1Proxy.Execute((data) => _loadInicialVistaInstanciaParametroInitialStateData(data, id), null, null);
}

function _loadInicialVistaInstanciaParametroInitialStateData(data, id) {
    LogHelper.In(_loadInicialVistaInstanciaParametroInitialStateData.name, data, id);

    _cantidadPaginas = JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset2.Rows[0].CantidadPaginas;

    let instancias;
    try {
        instancias = JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset1.Rows;
        let propiedadesVisibles = instancias ? instancias.filter(x => x.EstaVisible) : null;
        //Artilugio generado para que se tome el valor como una copia y no como una referencia directa de la variable "instancias"
        let comboInicial = instancias ? instancias.filter(x => x.EstaVisible) : null;

        let dataCompleto = {
            'entidad': JSON.parse(data.GET_ENTIDAD_BYID).Recordset0.Rows[0],
            //Es la cantidad que contiene la Entidad (Ej: Sucursales 245)
            'cantidadRegistrosEntidad': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset1.Rows[0].CantidadRegistrosEntidad * instancias.length,
            'cantidadInstanciasEntidad': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset1.Rows[0].CantidadRegistrosEntidad,
            //Es la cantidad de registros para paginar 
            'cantidadRegistrosParaPaginar': 0,
            //Es la cantidad de Propiedad Instancia que contiene la Entidad (Ej: ID, CODIGO, DESCRIPCION, etc...)
            'cantidadRegistrosPropiedadInstancia': 0,
            'propiedadInstancia': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset0.Rows,
            'entidadInstancia': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset0.Rows,
            'cantidadPaginas': _cantidadPaginas,
            'instancias': instancias,
            'paginaActual': 1,
            'propiedadesVisibleEnGrilla': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset4.Rows,
            'propiedadesVisibles': propiedadesVisibles,
            'comboInicial': comboInicial
        }

        _convertirFechaDB(dataCompleto.propiedadInstancia);

        _dispatch({ type: GET_DATA_VISTA_INSTANCIA_PARAMETROS_DATA, dataCompleto });
        _dispatch({ type: LOADING_ATLAS, valor: false });

    } catch (error) {
        console.log("Fallo Actions.js JSON.parse./n"
            + " Data obtenida: Linea 155- " + data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA
            + "/n Data obtenida: Linea 157- " + data.GET_ENTIDAD_BYID
            + "/n Data Obtenida: Linea 159- " + data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA)
    }
}

export function mostrarActivos(registrosActivos, paginaNumero, arrayFiltrosDefinitivo) {
    return (dispatch, getState) => {
        let state = getState();
        let entidadId = parseInt(state.atlas.entidadId);

        let mostrarActivos = registrosActivos ? true : null;
        state.vistaInstanciaParametro.data.ultimoRegistro = 0;

        _dispatch({ type: LOADING_ATLAS, valor: true });

        let entidadDatos = {
            'ENTIDAD_ID': entidadId,
            'NUMERO_PAGINA': paginaNumero,
            'REGISTROS_ACTIVOS': mostrarActivos,
            'CANTIDAD_REGISTROS': null,
            
            'PROPIEDAD_ID_1': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 0 ? arrayFiltrosDefinitivo[0].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_1': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 0 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[0]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_1': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 0 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[0]) : null,

            'PROPIEDAD_ID_2': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 1 ? arrayFiltrosDefinitivo[1].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_2': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 1 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[1]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_2': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 1 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[1]) : null,

            'PROPIEDAD_ID_3': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 2 ? arrayFiltrosDefinitivo[2].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_3': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 2 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[2]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_3': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 2 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[2]) : null,

            'PROPIEDAD_ID_4': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 3 ? arrayFiltrosDefinitivo[3].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_4': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 3 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[3]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_4': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 3 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[3]) : null,

            'PROPIEDAD_ID_5': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 4 ? arrayFiltrosDefinitivo[4].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_5': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 4 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[4]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_5': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 4 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[4]) : null
        }

        let idEntidad = {
            "ENTIDAD_ID": entidadId
        }

        let params = {
            "ENTIDAD_ID": entidadId,
            "ENTIDAD_INSTANCIA_ID": 0
        }

        LogHelper.Out(irAPagina.name, params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');

        LogHelper.Out(irAPagina.name, idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');

        LogHelper.Out(irAPagina.name, (entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product'));
        Engine1Proxy.AddDataSourcesRequests(entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product');


        Engine1Proxy.Execute((data) => _backMostrarActivos(data, paginaNumero));
    }
}

function _backMostrarActivos(data, paginaActual) {
    LogHelper.In(_backMostrarActivos.name, data, paginaActual);

    _cantidadPaginas = JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset2.Rows[0].CantidadPaginas;

    let instancias;
    try {
        instancias = JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset1.Rows;
        let propiedadesVisibles = instancias ? instancias.filter(x => x.EstaVisible) : null;
        //Artilugio generado para que se tome el valor como una copia y no como una referencia directa de la variable "instancias"
        let comboInicial = instancias ? instancias.filter(x => x.EstaVisible) : null;

        let dataCompleto = {
            'entidad': JSON.parse(data.GET_ENTIDAD_BYID).Recordset0.Rows[0],
            'cantidadRegistrosEntidad': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset1.Rows[0].CantidadRegistrosEntidad * instancias.length,
            'cantidadInstanciasEntidad': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset1.Rows[0].CantidadRegistrosEntidad,
            //Es la cantidad de registros para paginar 
            'cantidadRegistrosParaPaginar': 0,
            'cantidadRegistrosPropiedadInstancia': 0,
            'propiedadInstancia': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset0.Rows,
            'entidadInstancia': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset0.Rows,
            'cantidadPaginas': _cantidadPaginas,
            'ultimoRegistro': 0,
            'instancias': instancias,
            'paginaActual': paginaActual,
            'propiedadesVisibleEnGrilla': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset4.Rows,
            'propiedadesVisibles': propiedadesVisibles,
            'comboInicial': comboInicial
        }

        _convertirFechaDB(dataCompleto.propiedadInstancia);

        _dispatch({ type: GET_DATA_VISTA_INSTANCIA_PARAMETROS_DATA, dataCompleto });
        _dispatch({ type: LOADING_ATLAS, valor: false });

    } catch (error) {
        console.log("Fallo Actions.js JSON.parse./n"
            + " Data obtenida: Linea 155- " + data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA
            + "/n Data obtenida: Linea 157- " + data.GET_ENTIDAD_BYID
            + "/n Data Obtenida: Linea 159- " + data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA)
    }
}

export function irAPagina(paginaNumero, registrosActivos, arrayFiltrosDefinitivo) {
    return (dispatch, getState) => {

        let stateAtlas = getState().atlas;
        let entidadId = parseInt(stateAtlas.entidadId);
        let mostrarActivos = registrosActivos ? true : null;

        paginaNumero = paginaNumero > _cantidadPaginas ? _cantidadPaginas : paginaNumero;

        _dispatch({ type: LOADING_ATLAS, valor: true });

        let entidadDatos = {
            'ENTIDAD_ID': entidadId,
            'NUMERO_PAGINA': paginaNumero,
            'REGISTROS_ACTIVOS': mostrarActivos,
            'CANTIDAD_REGISTROS': null,

            'PROPIEDAD_ID_1': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 0 ? arrayFiltrosDefinitivo[0].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_1': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 0 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[0]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_1': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 0 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[0]) : null,

            'PROPIEDAD_ID_2': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 1 ? arrayFiltrosDefinitivo[1].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_2': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 1 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[1]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_2': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 1 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[1]) : null,

            'PROPIEDAD_ID_3': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 2 ? arrayFiltrosDefinitivo[2].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_3': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 2 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[2]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_3': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 2 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[2]) : null,

            'PROPIEDAD_ID_4': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 3 ? arrayFiltrosDefinitivo[3].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_4': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 3 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[3]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_4': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 3 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[3]) : null,

            'PROPIEDAD_ID_5': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 4 ? arrayFiltrosDefinitivo[4].instancia.PropiedadId : null,
            'VALOR_PROPIEDAD_5': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 4 ? obtenerValorPropiedad(arrayFiltrosDefinitivo[4]) : null,
            'TIPO_BUSQUEDA_PROPIEDAD_5': arrayFiltrosDefinitivo && arrayFiltrosDefinitivo.length > 4 ? obtenerTipoDeBusqueda(arrayFiltrosDefinitivo[4]) : null
        }

        let idEntidad = {
            "ENTIDAD_ID": entidadId
        }

        let params = {
            "ENTIDAD_ID": entidadId,
            "ENTIDAD_INSTANCIA_ID": 0
        }

        LogHelper.Out(irAPagina.name, params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID', 'Get', 'Atlas', 'Atlas', 1, 'Product');

        LogHelper.Out(irAPagina.name, idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(idEntidad, 'GET_ENTIDAD_BYID', 'Get', 'Atlas', 'Atlas', 1, 'Product');

        LogHelper.Out(irAPagina.name, (entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product'));
        Engine1Proxy.AddDataSourcesRequests(entidadDatos, 'GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA', 'Get', 'Atlas', 'Atlas', 1, 'Product');

        Engine1Proxy.Execute((data) => _callBackIrApagina(data, paginaNumero));
    }
}

function _callBackIrApagina(data, paginaNumero) {
    LogHelper.In(_callBackIrApagina.name, data, paginaNumero);

    let instancias;
    try {
        instancias = JSON.parse(data.GET_INSTANCIA_PARAMETRO_BY_ENTIDAD_ID).Recordset1.Rows;
        let propiedadesVisibles = instancias ? instancias.filter(x => x.EstaVisible) : null;
        //Artilugio generado para que se tome el valor como una copia y no como una referencia directa de la variable "instancias"
        let comboInicial = instancias ? instancias.filter(x => x.EstaVisible) : null;

        let dataCompleto = {
            'entidad': JSON.parse(data.GET_ENTIDAD_BYID).Recordset0.Rows[0],
            'cantidadRegistrosEntidad': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset1.Rows[0].CantidadRegistrosEntidad * instancias.length,
            'cantidadInstanciasEntidad': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset1.Rows[0].CantidadRegistrosEntidad,
            //Es la cantidad de registros para paginar 
            'cantidadRegistrosParaPaginar': 0,
            'cantidadRegistrosPropiedadInstancia': 0,
            'propiedadInstancia': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset0.Rows,
            'entidadInstancia': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset0.Rows,
            'cantidadPaginas': _cantidadPaginas,
            'ultimoRegistro': 0,
            'instancias': instancias,
            'paginaActual': paginaNumero,
            'propiedadesVisibleEnGrilla': JSON.parse(data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA).Recordset4.Rows,
            'propiedadesVisibles': propiedadesVisibles,
            'comboInicial': comboInicial
        }

        _convertirFechaDB(dataCompleto.propiedadInstancia);

        _dispatch({ type: GET_DATA_VISTA_INSTANCIA_PARAMETROS_DATA, dataCompleto });
        _dispatch({ type: LOADING_ATLAS, valor: false });

    } catch (error) {
        console.log("Fallo Actions.js JSON.parse./n"
            + " Data obtenida: Linea 155- " + data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA
            + "/n Data obtenida: Linea 157- " + data.GET_ENTIDAD_BYID
            + "/n Data Obtenida: Linea 159- " + data.GET_PROPIEDAD_INSTANCIA_BYID_PAGINADA)
    }
}

function _convertirFechaDB(data) {

    data.map((propiedad, i) => {

        if (propiedad.TipoCodigo == 'DATETIME' && propiedad.Valor != null && propiedad.Valor != "") {

            let fechaAux = propiedad.Valor.split('-')
            let fecha1 = ""
            let fecha2 = ""
            let mes = fechaAux[0].length > 1 ? fechaAux[0] : "0" + fechaAux[0]
            let dia = fechaAux[1].length > 1 ? fechaAux[1] : "0" + fechaAux[1]
            //fecha1 += mes + "-" + dia + "-" + fechaAux[2]
            fecha2 += dia + "-" + mes + "-" + fechaAux[2]

            propiedad.Valor = fecha2;
        }
    });
}

export function validacionErrorFormatoFiltro(propiedadId, esError, esFechaInvalida) {
    return (dispatch, getState) => {
        _dispatch({ type: ERROR_VALIDACION_FORMATO_FILTRO, propiedadId, esError, esFechaInvalida });
    };
}


// WEBPACK FOOTER //
// ./Portico/Productos/Atlas/App/Screens/VistaInstanciaParametro/actions/Actions.js